import { WordBank } from './index';

export const bajanWords: WordBank = {
  id: 'bajan',
  name: 'Bajan Dialect',
  description: 'Common Barbadian (Bajan) words and phrases',
  categories: ['greetings', 'food', 'expressions', 'people', 'weather', 'behavior', 'time', 'feelings'],
  words: [
    {
      word: "Wukkin Up",
      definition: "A style of dancing, typically involving rotating and gyrating the hips",
      difficulty: "medium",
      category: "entertainment",
      example: "She was wukkin up at the Crop Over festival"
    },
    {
      word: "Wuh Loss",
      definition: "An exclamation of surprise, shock, or dismay",
      difficulty: "easy",
      category: "expressions",
      example: "Wuh loss! The prices gone up again!"
    },
    {
      word: "Lime",
      definition: "To hang out or socialize with friends",
      difficulty: "easy",
      category: "entertainment",
      example: "We liming by the beach later"
    },
    {
      word: "Macaroni Pie",
      definition: "A baked macaroni and cheese dish, considered a national dish of Barbados",
      difficulty: "easy",
      category: "food",
      example: "Sunday lunch isn't complete without macaroni pie"
    },
    {
      word: "Wunna",
      definition: "You all, all of you (plural form of you)",
      difficulty: "medium",
      category: "expressions",
      example: "Wunna coming to the party?"
    },
    {
      word: "Doan Mine",
      definition: "Don't mind, don't worry about it, or never mind",
      difficulty: "medium",
      category: "expressions",
      example: "Doan mine he, he always like that"
    },
    {
      word: "Bajans",
      definition: "The people of Barbados",
      difficulty: "easy",
      category: "people",
      example: "Bajans love their flying fish"
    },
    {
      word: "Gine",
      definition: "Going to, gonna",
      difficulty: "medium",
      category: "expressions",
      example: "I gine to the shop"
    },
    {
      word: "Sweet Bread",
      definition: "A traditional Bajan coconut bread dessert",
      difficulty: "easy",
      category: "food",
      example: "Granny made sweet bread for Christmas"
    },
    {
      word: "Bout Here",
      definition: "Around here, in this area or place",
      difficulty: "easy",
      category: "expressions",
      example: "Things expensive bout here"
    },
    {
      word: "Cou-Cou",
      definition: "A traditional Barbadian dish made from cornmeal and okra",
      difficulty: "medium",
      category: "food",
      example: "We having flying fish and cou-cou for dinner"
    },
    {
      word: "Ignorant",
      definition: "Angry or upset (different from the standard English meaning)",
      difficulty: "hard",
      category: "feelings",
      example: "He got real ignorant when I tell he no"
    },
    {
      word: "Stush",
      definition: "Posh, fancy, or stuck up",
      difficulty: "medium",
      category: "behavior",
      example: "She too stush to eat at the local spot"
    },
    {
      word: "Wattle",
      definition: "A long time or a great distance",
      difficulty: "hard",
      category: "time",
      example: "I ain't see he in a wattle"
    },
    {
      word: "Brass Bowl",
      definition: "A foolish person",
      difficulty: "medium",
      category: "behavior",
      example: "Stop acting like a brass bowl!"
    }
  ]
}; 